export default "__VITE_PUBLIC_ASSET__8592636e__"